import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Button, Form, Input, InputNumber, Select, TextArea, TimePicker } from 'components/shared/FormComponent';
import { Empty, Switch, Table, TableProps, Tooltip, Popconfirm, message, } from 'components/shared/AntComponent';
import { DeleteFilled } from 'components/shared/AntIcons';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import { getCourse, getPublicCourse, getSpecialisation } from 'services/store/actions/masterDataAction';
import { addQuestionPaper } from 'services/store/actions/questionPaperAction';

interface ChildProps {
    slots: any;
    // applicantOptions: any;
    // department: any;
    callbackFunc: (val: any) => void;
    duration: any;
    rowData: any;
    isPastDate: boolean;
    tempOptions: any;
    college: any;
    examName: string;
    totalMark: any;
}

const AddSlotScreen: React.FC<ChildProps> = ({ callbackFunc, tempOptions, slots, rowData, duration, isPastDate, college, examName, totalMark }) => {
    const [form1] = Form.useForm();
    const dispatch = useDispatch();
    const { loading1, success1, error1 } = useSelector((state: any) => state.questionpaper);
    const { loading18 } = useSelector((state: any) => state.candidate);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const { loading21, courseInfo, loading12: specLoading, specialisationInfo, pubCourseInfo, loading30 } = useSelector((state: any) => state.master);
    const [options1, setOptions1]: any = useState([]);
    const [dependentOptions, setDependentOptions]: any = useState([]);
    const [options2, setOptions2]: any = useState([]);
    const [sectionTemplateMap, setSectionTemplateMap]: any = useState({});
    const [sectionDeptMap, setSectionDeptMap]: any = useState({});
    const [sectionAssCondMap, setSectionAssCondMap]: any = useState({});
    const [disableAddSection, setDisableAddSection] = useState(false);
    const [options3, setOptions3]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error1 : false;
    // const [currentSlot,setCurrentSlot]= useState

    // Use a ref to track the last initialized rowData ID
    const lastInitializedId = useRef<number | null>(null);

    const customLocale = {
        emptyText: <Empty className="p-2" description="No sections Available" />,
    };
    const deptOptions = useMemo(() =>
        !loading30 && pubCourseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0
        })) || [],
        [loading21, pubCourseInfo]
    );

    const courseOptions = useMemo(() =>
        !loading21 && courseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0,
        })) || [],
        [loading21, courseInfo]
    );

    const specOptions = useMemo(() =>
        !specLoading && specialisationInfo?.data?.map((item: any) => ({
            value: item?.specializationId,
            label: item?.specializationName,
            id: item?.specializationId,
            description: item.description,
            actualID: 0
        })) || [],
        [specLoading, specialisationInfo]
    );

    const genderOptions: any = useMemo(() => [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ], []);

    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getCourse(id) as any);
    }

    function getPublicCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getPublicCourse(id) as any);
    }

    function getSpecialisationDetails() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSpecialisation(id) as any);
    }

    useEffect(() => {
        getCourseList();
        getPublicCourseList();
        // getSpecialisationDetails();
    }, []);
    const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
    // console.log("slotttttttttttt", rowData);
    const formatExamStartTime = (examStartTime: any) => {
        // Check if the value matches the ISO 8601 format
        if (iso8601Regex.test(examStartTime)) {
            // If it matches, format it as 'HH:mm:ss'
            return dayjs(examStartTime).format('HH:mm:ss');
        } else {
            // If it doesn't match, return the original value
            return examStartTime;
        }
    };
    // Initialize form when rowData changes
    // useEffect(() => {
    //     const currentId = rowData?.ExamSlotId;
    //     console.log("rowData", rowData);

    //     // Only initialize if we have all required data and haven't initialized this rowData yet
    //     if (rowData && specOptions.length > 0 && courseOptions.length > 0 && currentId !== lastInitializedId.current) {
    //         lastInitializedId.current = currentId;

    //         const mainCondition = rowData?.IsAssoCondition;
    //         const sections = rowData?.QuestionPaper?.QpSections || [];

    //         // Set dependent options based on condition
    //         let depOptions1 = [];
    //         let opt1: any = [];

    //         if (mainCondition === "dept") {
    //             depOptions1 = deptOptions;
    //             opt1 = [
    //                 { value: "all", label: "All" },
    //                 { value: "dept", label: "Department" }
    //             ];
    //         } else if (mainCondition === "course") {
    //             depOptions1 = courseOptions;
    //             opt1 = [
    //                 { value: "all", label: "All" },
    //                 { value: "course", label: "Course" }
    //             ];
    //         } else if (mainCondition === "gender") {
    //             depOptions1 = genderOptions;
    //             opt1 = [
    //                 { value: "all", label: "All" },
    //                 { value: "gender", label: "Gender" }
    //             ];
    //         }

    //         setDependentOptions(depOptions1);
    //         setOptions1(opt1);

    //         // Build section maps
    //         const assCondMap: any = {};
    //         const deptMap: any = {};
    //         const templateMap: any = {};

    //         sections.forEach((sec: any, index: number) => {
    //             assCondMap[index] = sec.IsAssoCondition;
    //             if (sec.ConditionName) {
    //                 deptMap[index] = sec.IsAssoCondition === "all" ? "aptitude" : Number(sec.ConditionName);
    //             }
    //             if (sec.QuesTemplateID) {
    //                 templateMap[index] = Number(sec.QuesTemplateID);
    //             }
    //         });

    //         setSectionAssCondMap(assCondMap);
    //         setSectionDeptMap(deptMap);
    //         setSectionTemplateMap(templateMap);

    //         // Set options2/options3
    //         const selectedValues = Array.isArray(rowData?.ConditionIDs)
    //             ? rowData.ConditionIDs.map((v: any) => Number(v))
    //             : [];

    //         const opts = mainCondition === "dept" ? deptOptions :
    //             mainCondition === "course" ? courseOptions :
    //                 mainCondition === "gender" ? genderOptions : [];

    //         const filteredOpts = opts?.filter((item: any) => selectedValues?.includes(item.value))?.map((item: any) => ({
    //             label: item.label,
    //             value: item.value
    //         })) || [];
    //         // Get the IDs from ConditionIDs (which contains the actual values)
    //         const conditionIDs = rowData?.ConditionIDs
    //             ? rowData.ConditionIDs.split(',').map((v: string) => {
    //                 // Check if it's a number or string value (for gender)
    //                 const numVal = Number(v.trim());
    //                 return isNaN(numVal) ? v.trim() : numVal;
    //             })
    //             : [];

    //         const opts1 = mainCondition === "dept" ? deptOptions :
    //             mainCondition === "course" ? courseOptions :
    //                 mainCondition === "gender" ? genderOptions : [];

    //         const filteredOpts1 = opts1?.filter((item: any) =>
    //             conditionIDs?.includes(item.value)
    //         )?.map((item: any) => ({
    //             label: item.label,
    //             value: item.value
    //         })) || [];

    //         setOptions2(filteredOpts);
    //         setOptions3(filteredOpts);

    //         // Set form values
    //         form1.setFieldsValue({
    //             slotStartTime: rowData?.ExamStartTime ? dayjs(rowData?.ExamStartTime, 'HH:mm:ss') : null,
    //             slotEndTime: rowData?.ExamEndTime ? dayjs(rowData?.ExamEndTime, 'HH:mm:ss') : null,
    //             slotName: rowData?.ExamSlotName,
    //             status: rowData?.Status,
    //             capacity: rowData?.TotalCapacity,
    //             associateCondition: rowData?.IsAssoCondition,
    //             ConditName: rowData?.ConditionName,
    //             deptCourseGender: rowData?.ConditionIDs,
    //             quesPaperName: rowData?.QuestionPaper?.QuesPaperName || "",
    //             easypercent: rowData?.QuestionPaper?.EasyPercent || null,
    //             mediumpercent: rowData?.QuestionPaper?.MediumPercent || null,
    //             hardpercent: rowData?.QuestionPaper?.HardPercent || null,
    //             notes: rowData?.QuestionPaper?.Notes || "",
    //             sections: sections?.map((item: any) => ({
    //                 sectionID: item.QpSectionID || 0,
    //                 sectionName: item.QpSectionName || "",
    //                 assCondition: item.IsAssoCondition || "",
    //                 department: item.IsAssoCondition === "all" ? "aptitude" : (item.ConditionName ? Number(item.ConditionName) : undefined),
    //                 template: item.QuesTemplateID ? Number(item.QuesTemplateID) : undefined
    //             }))
    //         });
    //     } else if (!rowData) {
    //         // Reset when no rowData
    //         lastInitializedId.current = null;
    //     }
    // }, [rowData, specOptions, courseOptions, genderOptions]);

    useEffect(() => {
        const currentId = rowData?.ExamSlotId;

        // Only initialize if we have all required data and haven't initialized this rowData yet
        if (rowData && currentId !== lastInitializedId.current) {
            lastInitializedId.current = currentId;

            const mainCondition = rowData?.IsAssoCondition;
            const sections = rowData?.QuestionPaper?.QpSections || [];

            // Set dependent options based on condition
            let depOptions1 = [];
            let opt1: any = [];

            if (mainCondition === "dept") {
                depOptions1 = deptOptions;
                opt1 = [
                    { value: "all", label: "All" },
                    { value: "dept", label: "Department" }
                ];
            } else if (mainCondition === "course") {
                depOptions1 = courseOptions;
                opt1 = [
                    { value: "all", label: "All" },
                    { value: "course", label: "Course" }
                ];
            } else if (mainCondition === "gender") {
                depOptions1 = genderOptions;
                opt1 = [
                    { value: "all", label: "All" },
                    { value: "gender", label: "Gender" }
                ];
            }

            setDependentOptions(depOptions1);
            setOptions1(opt1);

            // Build section maps
            const assCondMap: any = {};
            const deptMap: any = {};
            const templateMap: any = {};

            sections.forEach((sec: any, index: number) => {
                assCondMap[index] = sec.IsAssoCondition;
                if (sec.ConditionName) {
                    deptMap[index] = sec.IsAssoCondition === "all" ? "aptitude" : Number(sec.ConditionName);
                }
                if (sec.QuesTemplateID) {
                    templateMap[index] = Number(sec.QuesTemplateID);
                }
            });

            setSectionAssCondMap(assCondMap);
            setSectionDeptMap(deptMap);
            setSectionTemplateMap(templateMap);

            // Parse ConditionIDs - handle different formats
            let conditionIDs: any[] = [];

            if (rowData?.ConditionIDs) {
                // If it's already an array
                if (Array.isArray(rowData.ConditionIDs)) {
                    conditionIDs = rowData.ConditionIDs.map((v: any) => {
                        const numVal = Number(v);
                        return isNaN(numVal) ? v : numVal;
                    });
                }
                // If it's a comma-separated string
                else if (typeof rowData.ConditionIDs === 'string') {
                    conditionIDs = rowData.ConditionIDs.split(',').map((v: string) => {
                        const trimmed = v.trim();
                        const numVal = Number(trimmed);
                        return isNaN(numVal) ? trimmed : numVal;
                    });
                }
                // If it's a single value
                else {
                    const numVal = Number(rowData.ConditionIDs);
                    conditionIDs = [isNaN(numVal) ? rowData.ConditionIDs : numVal];
                }
            }


            // Get the appropriate options based on condition type
            const opts = mainCondition === "dept" ? deptOptions :
                mainCondition === "course" ? courseOptions :
                    mainCondition === "gender" ? genderOptions : [];

            // Filter options that match the conditionIDs
            const filteredOpts = opts?.filter((item: any) =>
                conditionIDs?.includes(item.value)
            )?.map((item: any) => ({
                label: item.label,
                value: item.value
            })) || [];

            setOptions2(filteredOpts);
            setOptions3(filteredOpts);

            // Parse ConditionName - handle different formats
            let conditionNames: any[] = [];

            if (rowData?.ConditionName) {
                if (Array.isArray(rowData.ConditionName)) {
                    conditionNames = rowData.ConditionName;
                } else if (typeof rowData.ConditionName === 'string') {
                    // Try to split by comma if it's a string
                    conditionNames = rowData.ConditionName.includes(',')
                        ? rowData.ConditionName.split(',').map((s: string) => s.trim())
                        : [rowData.ConditionName];
                } else {
                    conditionNames = [rowData.ConditionName];
                }
            }

            // Set form values
            const formValues = {
                slotStartTime: rowData?.ExamStartTime ? dayjs(rowData?.ExamStartTime, 'HH:mm:ss') : null,
                slotEndTime: rowData?.ExamEndTime ? dayjs(rowData?.ExamEndTime, 'HH:mm:ss') : null,
                slotName: rowData?.ExamSlotName,
                status: rowData?.Status,
                capacity: rowData?.TotalCapacity,
                associateCondition: rowData?.IsAssoCondition,
                ConditionName: conditionNames,
                deptCourseGender: conditionIDs,
                quesPaperName: rowData?.QuestionPaper?.QuesPaperName || "",
                easypercent: rowData?.QuestionPaper?.EasyPercent || null,
                mediumpercent: rowData?.QuestionPaper?.MediumPercent || null,
                hardpercent: rowData?.QuestionPaper?.HardPercent || null,
                notes: rowData?.QuestionPaper?.Notes || "",
                sections: sections?.map((item: any) => ({
                    sectionID: item.QpSectionID || 0,
                    sectionName: item.QpSectionName || "",
                    assCondition: item.IsAssoCondition || "",
                    department: item.IsAssoCondition === "all" ? "aptitude" : (item.ConditionName ? Number(item.ConditionName) : undefined),
                    template: item.QuesTemplateID ? Number(item.QuesTemplateID) : undefined
                }))
            };

            form1.setFieldsValue(formValues);

            // Verify what was actually set
            setTimeout(() => {
                console.log("Form values after set:", form1.getFieldsValue());
            }, 100);
        } else if (!rowData) {
            // Reset when no rowData
            lastInitializedId.current = null;
        }
    }, [rowData, specOptions, courseOptions, genderOptions, deptOptions]);

    useEffect(() => {
        const start = form1.getFieldValue('slotStartTime');
        if (start && duration) {
            const end = dayjs(start).add(duration, 'minute');
            form1.setFieldValue('slotEndTime', end);
        }
    }, [duration, form1]);

    const handleTimeChange = async (value: any) => {
        if (!value) return;
        const durations = duration || 30;

        const start = value?.second(0);
        const end = start.add(durations, 'minute');
        form1.setFieldValue('slotEndTime', end);
        form1.setFieldValue('slotStartTime', start);
    }

const addForm = async () => {
  try {
    const value = await form1.validateFields();

    // 🔒 FINAL BUSINESS VALIDATION (must be exactly 100)
    const totalPercent =
      Number(value.easypercent || 0) +
      Number(value.mediumpercent || 0) +
      Number(value.hardpercent || 0);

    if (totalPercent !== 100) {
      message.error("Total percentage must be exactly 100%");
      return; // ⛔ stop submission
    }

    const slotInfo = {
      ExamSlotId: rowData?.ExamSlotId || 0,
      ExamID: rowData?.ExamID || 0,
      ExamSlotName: value.slotName,
      ExamStartTime: value.slotStartTime
        ? dayjs(value.slotStartTime).format("HH:mm:ss")
        : null,
      ExamEndTime: value.slotEndTime
        ? dayjs(value.slotEndTime).format("HH:mm:ss")
        : null,
      ExamDuration: rowData?.ExamDuration?.toString() || "",
      IsAssoCondition: value.associateCondition || "",
      ConditionIDs: value.deptCourseGender?.toString() || "",
      ConditionName: value.ConditName?.toString() || "",
      TotalCapacity: value.capacity || "",
      Status: value.status || "active",
      TenantId: Number(localStorage.getItem("tenantID")),
      AccountId: Number(rowData?.AccountId) || null,

      QuestionPaper: {
        QuesPaperID: 0,
        QuesPaperName: value.quesPaperName || "",
        QuesGenMode: "Auto",
        ExamID: rowData?.ExamID || 0,
        ExamName: rowData?.ExamName || "",
        SlotID: rowData?.ExamSlotId || 0,
        SlotName: value.slotName || "",
        NoOfQuestions: rowData?.TotalMark,
        TotalMarks: rowData?.TotalMark,
        Notes: value.notes || "",
        TenantId: Number(localStorage.getItem("tenantID")),
        EasyPercent: value.easypercent,
        MediumPercent: value.mediumpercent,
        HardPercent: value.hardpercent,
        IsCombinedTemplate: true,

        QpSections: value?.sections?.map((item: any) => ({
          QpSectionID: 0,
          QuesPaperID: 0,
          QpSectionName: item.sectionName,
          IsAssoCondition: item.assCondition,
          ConditionName: item.department?.toString() || "",
          QuesTemplateID: Number(item.template),
          QuesTemplateName: item.template
            ? tempOptions?.find(
                (itm: any) => itm.value == item.template
              )?.label
            : "",
          TenantId: Number(localStorage.getItem("tenantID")),
          modifiedOn: "2025-11-03T06:25:40.4374283Z",
          createdOn: "2025-11-03T06:25:40.4374283Z",
        })),
      },
    };

    generatePaper(slotInfo);
    setSelectedRowKeys([]);

  } catch (errorInfo) {
    console.log("error", errorInfo);
  }
};


const isAtLeastOneSectionComplete = () => {
  const sections = form1.getFieldValue("sections") || [];

  if (!sections.length) return false;

  return sections.some((section: any) =>
    section?.sectionName &&
    section?.assCondition &&
    section?.department &&
    section?.template
  );
};



    const handleDeptChange = (rowIndex: number, value: any) => {
        setSectionDeptMap((prev: any) => ({
            ...prev,
            [rowIndex]: value
        }));
    };

    const handleAssConditionChange = (rowIndex: number, value: any) => {
        setSectionAssCondMap((prev: any) => ({
            ...prev,
            [rowIndex]: value
        }));

        if (value === "all") {
            const sections = form1.getFieldValue('sections') || [];
            sections[rowIndex] = {
                ...sections[rowIndex],
                department: undefined
            };
            form1.setFieldValue('sections', sections);

            setSectionDeptMap((prev: any) => {
                const newMap = { ...prev };
                delete newMap[rowIndex];
                return newMap;
            });
        }
        handleAssCondition(value);
        checkDisableAddSection();
    };

    const getFilteredAssConditions = (rowIndex: number) => {
        const selectedValues = Object.entries(sectionAssCondMap)
            .filter(([key]) => Number(key) !== rowIndex)
            .map(([, value]) => value);

        return options1.filter((item: any) => {
            if (sectionAssCondMap[rowIndex] === item.value) return true;

            if (item.value === "all" && selectedValues.includes("all")) {
                return false;
            }

            return true;
        });
    };

    const getFilteredDepartments = (rowIndex: number) => {
        const currentAssCondition = sectionAssCondMap[rowIndex];

        // If "all" is selected, show aptitude option
        if (currentAssCondition === "all") {
            return [{ value: "aptitude", label: "Aptitude" }];
        }

        // Otherwise, filter based on selected departments
        const selectedDepts = Object.values(sectionDeptMap);

        return options2?.filter((item: any) => {
            if (sectionDeptMap[rowIndex] === item.value) return true;
            return !selectedDepts.includes(item.value);
        });
    };

    const options = [
        { label: "Department", value: "dept" },
        { label: "Course", value: "course" },
        { label: "Gender", value: "gender" }
    ];

    const handleTemplateChange = (rowIndex: number, value: any) => {
        setSectionTemplateMap((prev: any) => ({
            ...prev,
            [rowIndex]: value
        }));
    };

    const getFilteredTemplates = (rowIndex: number) => {
        const selectedTemplates = Object.values(sectionTemplateMap);

        return tempOptions.filter((item: any) => {
            if (sectionTemplateMap[rowIndex] === item.value) return true;
            return !selectedTemplates.includes(item.value);
        });
    };

    const checkDisableAddSection = () => {
        setTimeout(() => {
            const sections = form1.getFieldValue('sections') || [];

            const hasAllAssCondition = sections.some((section: any) =>
                section?.assCondition === "all"
            );

            const allSelectedDepts = sections
                .map((section: any) => section?.department)
                .filter(Boolean);

            const allDepartmentsSelected = options3.length > 0 &&
                options3.every((opt: any) => allSelectedDepts.includes(opt.value));

            setDisableAddSection(hasAllAssCondition && allDepartmentsSelected);
        }, 0);
    };

    const handleFormChange = (val: any) => {
        if (val) {
            const sections = form1.getFieldValue('sections') || [];
            const clearedSections = sections && sections.map((section: any) => ({
                ...section,
                assCondition: null,
                department: null,
            }));
            form1.setFieldValue('sections', clearedSections);

            setSectionAssCondMap({});
            setSectionDeptMap({});
            setOptions2([]);
            setDisableAddSection(false);

            if (val === "dept") {
                setDependentOptions(deptOptions);
                const opt = [
                    { value: "all", label: "All" },
                    { value: "dept", label: "Department" }
                ];
                setOptions1(opt);
                form1.setFieldValue("deptCourseGender", null);
                form1.setFieldValue("ConditName", null);
            } else if (val === "course") {
                setDependentOptions(courseOptions);
                const opt = [
                    { value: "all", label: "All" },
                    { value: "course", label: "Course" }
                ];
                setOptions1(opt);
                form1.setFieldValue("deptCourseGender", null);
                form1.setFieldValue("ConditName", null);
            } else if (val === "gender") {
                setDependentOptions(genderOptions);
                const opt = [
                    { value: "all", label: "All" },
                    { value: "gender", label: "Gender" }
                ];
                setOptions1(opt);
                form1.setFieldValue("deptCourseGender", null);
                form1.setFieldValue("ConditName", null);
            }
        }
    };

    const handleAssCondition = (e: any) => {
        if (e == "all") {
            setOptions2([{ value: "aptitude", label: 'Aptitude' }]);
        } else {
            const value = form1.getFieldValue('deptCourseGender');
            const dept = form1.getFieldValue('associateCondition');

            const opts = dept === "dept" ? deptOptions : dept === "course" ? courseOptions : dept == "gender" ? genderOptions : [];
            const opt = opts?.filter((item: any) => value?.includes(item.value))?.map((item: any) => ({
                label: item.label,
                value: item.value
            })) || [];
            setOptions2(opt);
            setOptions3(opt);
        }

        setTimeout(() => {
            checkDisableAddSection();
        }, 100);
    }

    const statusOption = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    const validatePercentage = ({ getFieldValue }: any) => ({
        validator(_: any, value: any) {
            const easy = Number(getFieldValue("easypercent") || 0);
            const medium = Number(getFieldValue("mediumpercent") || 0);
            const hard = Number(getFieldValue("hardpercent") || 0);

            const total = easy + medium + hard;

            if (total !== 100) {
                return Promise.reject("Total percentage must be exactly 100%");
            }
            return Promise.resolve();
        },
    });

    const getFilteredAssociateConditionOptions = () => {
        const usedConditions = slots
            ?.map((slot: any) => slot?.IsAssoCondition)
            .filter(Boolean) || [];

        const currentValue = rowData?.IsAssoCondition;

        return options.filter((opt) => {
            if (currentValue === opt.value) return true;
            return !usedConditions.includes(opt.value);
        });
    };

    const handleDeptChange1 = (e: any) => {

        // Step 1: Get the selected value from e
        const selectedValues = e;  // `e` is assumed to be an array of selected values

        // Step 2: Filter `dependentOptions` to get labels corresponding to the selected values
        const selectedLabels = dependentOptions
            .filter((option: any) => selectedValues.includes(option.value))  // Check if the value is in the selected array
            .map((option: any) => option.label);  // Extract labels



        // Step 3: Set the labels to the form field "ConditionIDs"
        form1.setFieldsValue({ ConditName: selectedLabels });
    };

    const generatePaper = (value: any) => {
        const ques = value?.QuestionPaper || null;
        const inputJson = {
            "QuesPaperID": 0,
            "QuesPaperName": ques?.QuesPaperName,
            "NoOfQuestions": ques?.TotalMarks || 100,
            "TotalMarks": ques?.TotalMarks || 100,
            "QuesGenMode": ques?.QuesGenMode || "Auto",
            "ExamID": ques?.ExamID || 0,
            "ExamName": ques?.ExamName || "",
            "SlotID": ques?.SlotID,
            "SlotName": ques?.SlotName || "",
            "Notes": ques?.Notes || "",
            "TenantId": ques?.TenantId || 1,
            "EasyPercent": ques?.EasyPercent || 0,
            "MediumPercent": ques?.MediumPercent || 0,
            "HardPercent": ques?.HardPercent || 0,
            "IsCombinedTemplate": true,
            "Status": "Active",
            "QpSections": ques?.QpSections || null
        }
        dispatch(addQuestionPaper(inputJson) as any);
        setShowSuccessmsg(true);
        setShowErrormsg(true);
    }

    useEffect(() => {
        if (successmsg) {
            message.success("Question Paper generated successfully");
            setShowSuccessmsg(false);
            callbackFunc(rowData);
        }
        if (errormsg) {
            if (error1?.message) {
                message.error(error1?.message);
            } else {
                message.error("Question Paper couldn't be generated");
            }
        }
    }, [successmsg, errormsg]);

    return (
        <div className='border-top pt-3'>
            <div className='bg-light p-3 rounded d-flex'>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">Slot Name</h6>
                    <p className="mb-0">{rowData?.ExamSlotName || "--"}</p>
                </div>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">Start Time</h6>
                    <p className="mb-0">{rowData?.ExamStartTime || "--"}</p>
                </div>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">End Time</h6>
                    <p className="mb-0">{rowData?.ExamEndTime || "--"}</p>
                </div>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">Capacity</h6>
                    <p className="mb-0">{rowData?.TotalCapacity || "--"}</p>
                </div>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">Associate Condition</h6>
                    <p className="mb-0">{rowData?.IsAssoCondition?.toLowerCase() === "dept" ? "Department" :
                        rowData?.IsAssoCondition?.toLowerCase() === 'course' ? "Course" : rowData?.IsAssoCondition?.toLowerCase() === "gender" ? "Gender" : "--"}</p>
                </div>
                <div className='col-md-2'>
                    <h6 className="text-blue fw-bold">Department/Course/Gender</h6>
                    <p className="mb-0">{Array.isArray(rowData.ConditionName) ? rowData?.ConditionName?.join(', ') : rowData?.ConditionName?.toString() || "--"}</p>
                </div>
            </div>
            <Form form={form1} onFinish={addForm} layout="vertical" >
                <div className='row mx-0 mb-2 bg-light p-3'>

                    <Form.Item label="Slot Name" hidden name="slotName" className='col ps-0'
                        rules={[{ required: true, message: 'This field is required' }]}>
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="Start Time" hidden name="slotStartTime" className='col-md-1 ps-1'
                        rules={[{ required: true, message: 'This field is required' }]}>
                        <TimePicker
                            onChange={(e) => handleTimeChange(e)}
                            format="hh:mm a"
                            className="w-100"
                            disabled
                            disabledTime={() => {
                                if (!slots || slots.length === 0) return {};

                                const prevStart = slots[slots.length - 1]?.slotStartTime;
                                if (!prevStart) return {};

                                const prevHour = dayjs(prevStart).hour();
                                const prevMinute = dayjs(prevStart).minute();
                                const isPM = prevHour >= 12;
                                let prevHour12 = prevHour % 12;
                                if (prevHour12 === 0) prevHour12 = 12;

                                return {
                                    disabledHours: () =>
                                        Array.from({ length: prevHour12 - 1 }, (_, i) => i + 1),
                                    disabledMinutes: (hour) => {
                                        if (hour === prevHour12) {
                                            return Array.from({ length: prevMinute + 1 }, (_, i) => i);
                                        }
                                        return [];
                                    },
                                };
                            }}
                        />
                    </Form.Item>
                    <Form.Item label="End Time" hidden name="slotEndTime" className='col-md-1 ps-1'>
                        <TimePicker format="hh:mm a" className="w-100" disabled placeholder='Select start time' />
                    </Form.Item>
                    <Form.Item label="Capacity" hidden name="capacity" className='col-md-2 ps-1' rules={[{ required: true, message: "This field is required" }]}>
                        <InputNumber className='w-100' disabled />
                    </Form.Item>
                    <Form.Item label="Associate Condition" hidden name="associateCondition" className='col-md-2 ps-1' rules={[{ required: true, message: "This field is required" }]}>
                        <Select
                            options={getFilteredAssociateConditionOptions()}
                            onChange={handleFormChange}
                            className='pt-1'
                            disabled
                        />
                    </Form.Item>
                    <Form.Item
                        label="Department/Course/Gender" hidden
                        name="deptCourseGender"
                        className="col-md-2 ps-1"
                        rules={[{ required: true, message: "This field is required" }]}
                    >
                        <Select
                            placeholder="Select"
                            mode="multiple"
                            disabled
                            options={dependentOptions}
                            className="pt-1"
                            onChange={(e: any) => handleDeptChange1(e)}
                        />
                    </Form.Item>
                    <Form.Item name="ConditName" hidden>
                        <Input disabled />
                    </Form.Item>

                    <Form.Item label="Status" name="status" hidden className='col-md-2 ps-1 pe-0' rules={[{ required: true, message: 'This field is required' }]}>
                        <Select options={statusOption} className='pt-1' disabled />
                    </Form.Item>
                    <div className='p-3 bg-white custom-table border'>
                        <div className='px-0 mb-4'>
                            <h6 className='text-secondary fw-bold my-auto py-2 ps-0'>Question paper generation</h6>
                        </div>
                        <div className='row m-0 px-0'>
                            <Form.Item label="Paper Name" name="quesPaperName" className='col-md-2 ps-0 '>
                                <Input />
                            </Form.Item>
                       <Form.Item
  label="Easy %"
  name="easypercent"
  className="col-md-2 ps-1"
  rules={[
    { required: true, message: "This field is required" },
    { type: "number", min: 0, max: 100, message: "Must be between 0 and 100" },
  ]}
>
  <InputNumber className="w-100" />
</Form.Item>

<Form.Item
  label="Medium %"
  name="mediumpercent"
  className="col-md-2 ps-1"
  rules={[
    { required: true, message: "This field is required" },
    { type: "number", min: 0, max: 100, message: "Must be between 0 and 100" },
  ]}
>
  <InputNumber className="w-100" />
</Form.Item>

<Form.Item
  label="Hard %"
  name="hardpercent"
  className="col-md-2 ps-1"
  rules={[
    { required: true, message: "This field is required" },
    { type: "number", min: 0, max: 100, message: "Must be between 0 and 100" },
  ]}
>
  <InputNumber className="w-100" />
</Form.Item>



                            <Form.Item label="Notes" name="notes" className='col-md-12 ps-0'>
                                <TextArea rows={2} />
                            </Form.Item>
                        </div>
                        <Form.List name="sections">
                            {(fields, { add, remove }) => {
                                const dataSource = fields.map((field) => ({
                                    key: field.key,
                                    index: field.name,
                                }));

                                return (
                                    <div>
                                        <div className='row mx-0 mb-2 justify-content-between page-header'>
                                            <h6 className='col my-auto fw-bold ps-0 text-dark'>Section Details</h6>
                                            <div className='text-end col-md-8'>
                                                <Tooltip title={disableAddSection ? "Cannot add section when 'All' with 'Aptitude' is selected" : !duration ? "Please select duration first" : ""}>
                                                    <Button
                                                        type="primary"
                                                        className="mt-2 col-md-2"
                                                        onClick={() => add()}
                                                        disabled={disableAddSection}
                                                    >
                                                        Add Section
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <Table
                                            dataSource={dataSource}
                                            pagination={false}
                                            className='custom-table border'
                                            rowKey="key"
                                            locale={customLocale}
                                            columns={[
                                                {
                                                    title: "Section Name",
                                                    dataIndex: "index",
                                                    width: "20%",
                                                    render: (index: number) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, "sectionName"]}
                                                            rules={[
                                                                { required: true, message: "This field is required" },
                                                                ({ getFieldValue }) => ({
                                                                    validator(_, value) {
                                                                        const all = getFieldValue("sections") || [];
                                                                        const dupe = all.filter(
                                                                            (item: any) =>
                                                                                item.sectionName &&
                                                                                item.sectionName.toLowerCase() ===
                                                                                value?.toLowerCase()
                                                                        );
                                                                        return dupe.length > 1
                                                                            ? Promise.reject("Duplicate section name")
                                                                            : Promise.resolve();
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: "Associate Condition",
                                                    dataIndex: "index",
                                                    width: "20%",
                                                    render: (index: number) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, "assCondition"]}
                                                            rules={[{ required: true, message: "This field is required" }]}
                                                        >
                                                            <Select
                                                                placeholder="Select"
                                                                options={getFilteredAssConditions(index)}
                                                                onChange={(value) => handleAssConditionChange(index, value)}
                                                            />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: "Department",
                                                    dataIndex: "index",
                                                    width: "20%",
                                                    render: (index: number) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, "department"]}
                                                            rules={[{ required: true, message: "This field is required" }]}
                                                        >
                                                            <Select
                                                                placeholder="Select"
                                                                options={getFilteredDepartments(index)}
                                                                onChange={(value) => {
                                                                    handleDeptChange(index, value);
                                                                    checkDisableAddSection();
                                                                }}
                                                            />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: "Template",
                                                    dataIndex: "index",
                                                    width: "20%",
                                                    render: (index: number) => (
                                                        <Form.Item
                                                            className="mb-0"
                                                            name={[index, "template"]}
                                                            rules={[{ required: true, message: "This field is required" }]}
                                                        >
                                                            <Select
                                                                placeholder="Select"
                                                                options={getFilteredTemplates(index)}
                                                                onChange={(value) => handleTemplateChange(index, value)}
                                                            />
                                                        </Form.Item>
                                                    ),
                                                },
                                                {
                                                    title: "Action",
                                                    dataIndex: "index",
                                                    width: "10%",
                                                    render: (index: number) => (
                                                        <>
                                                            {index == 0 ? <span className="pb-2 fs-17">
                                                                <DeleteFilled className="text-muted " />
                                                            </span> :
                                                                <Popconfirm
                                                                    title="Delete Section"
                                                                    description="Are you sure to delete this section?"
                                                                    onConfirm={() => {
                                                                        remove(index);
                                                                        checkDisableAddSection();
                                                                    }}
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                >
                                                                    <span className="pb-2 fs-17">
                                                                        <DeleteFilled className="text-danger pointer" />
                                                                    </span>
                                                                </Popconfirm>
                                                            }
                                                        </>
                                                    ),
                                                },
                                            ]}
                                        />
                                        {/* <Button type="primary" className='my-2' onClick={generatePaper}>Generate Paper</Button> */}
                                    </div>
                                );
                            }}
                        </Form.List>
                    </div>
                </div>
                 <Form.Item shouldUpdate noStyle>
    {() => null}
  </Form.Item>

                <div className="text-end">
                    <Tooltip title={selectedRowKeys?.length == 0 ? "Associate candidates to create slot" : ""}>
                       <Button
  type="primary"
  onClick={addForm}
  className="ms-auto mt-3 text-end"
  loading={loading1}
  disabled={!isAtLeastOneSectionComplete()}
>
  Generate Paper
</Button>

                    </Tooltip>
                </div>
            </Form>
        </div>
    )
}

export default AddSlotScreen;